import { render, staticRenderFns } from "./ProductCategoryFormModal.vue?vue&type=template&id=0db34ce0&"
import script from "./ProductCategoryFormModal.ts?vue&type=script&lang=js&"
export * from "./ProductCategoryFormModal.ts?vue&type=script&lang=js&"
import style0 from "./ProductCategoryFormModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports